<template>
  <div class="app-container">
    <el-container class="bg">
      <el-aside class="left_bg">
        <leftMenuDiv ref="leftMenuDiv"></leftMenuDiv>
      </el-aside>
      <el-main class="content-box">
        <router-view></router-view>
      </el-main>
    </el-container>
    <div class="watermark" v-if="username">
      <span v-for="n in 80" :key="n" :style="getWatermarkStyle(n)">{{ username }}{{ deptName ? '【' + deptName + '】' : '' }}</span>
    </div>
  </div>
</template>

<script>
import { GetAttachmentPath } from "@/api/systemApi.js";
import leftMenuDiv from "./mainIndex/leftMenu.vue";
export default {
  data() {
    return {
      userInfo: {},
      roleInfo: {},
      loading: false,
      username: "",
      deptName: "",
    };
  },
  components: {
    leftMenuDiv,
  },
  mounted() {
    this.getFileInfoPathData();
    this.userInfo = JSON.parse(localStorage.getItem("setUserInfo")) || {};
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata && userdata.userInfo) {
      this.username = userdata.userInfo.chName;
      this.deptName = userdata.userInfo.dept || '';
    }
  },
  methods: {
    // 获取附件前缀
    getFileInfoPathData() {
      GetAttachmentPath()
        .then((res) => {
          if (res.code === 1) {
            localStorage.setItem("filePath", res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    // 退出登录
    clickLoginout() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        setTimeout(() => {
          if (this.$tabs) {
            this.$tabs.reset();
          }
          localStorage.clear();
          this.$router.replace({
            path: "/login",
          });
          this.$message({
            type: "success",
            message: "已退出登录!",
          });
        }, 300);
      });
    },

    // 水印位置计算
    getWatermarkStyle(index) {
      const col = (index - 1) % 8;
      const row = Math.floor((index - 1) / 8);
      const top = 80 + row * 180;
      const left = 80 + col * 250;
      return {
        top: top + "px",
        left: left + "px",
      };
    },
  },
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>

<style scoped lang="scss">
html, body {
  width: 100%;
  height: 100%;
}

.bg {
  width: 100%;
  background: #ffffff;
  height: calc(100vh - 3.5rem);
  overflow: auto;
}

.app-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.left_bg {
  width: 260px !important;
  background: #e5e5e5;
  height: calc(100vh - 3.5rem);
  border: 0px solid rgba(34, 34, 56, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.el-card__body,
.el-main {
  padding: 0px !important;
  // padding-top: 8px !important;
  border: 4px solid #e5e5e5;
  border-left: none;
  overflow: hidden;
}

.watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
}

.watermark span {
  position: absolute;
  top: 150px;
  left: 150px;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.08);
  white-space: nowrap;
  transform: rotate(-45deg);
  transform-origin: left top;
}
</style>